module.exports = __webpack_public_path__ + "static/media/xt-square.cb6713f7.png";